<page-toolbar [title]="title" [pageActions]="pageActions"></page-toolbar>

<page-content [noPadding]="true">
  <div class="container" *ngIf="!loading">
    <div class="menu-buttons" *ngIf="navigationPoints?.length > 1">
      <div class="menu-button" *ngFor="let navigation of navigationPoints" (click)="updateNavigation(navigation)"
           [ngClass]="{ active: navigation === activeNavigation }">
        {{ 'userAdmin.' + navigation | translate }}
      </div>
    </div>
    <div class="content">
      <data-table *ngIf="activeNavigation === 'groups' && groupParams" (edit)="selected($event)" (remove)="deleteGroup($event)"
                  [columns]="groupColumns" [newHeader]="true" [searchAll]="true" [dataProviderParams]="groupParams"
                  [dataProvider]="groupService" [title]="'userAdmin.' + activeNavigation | translate" [headerButtons]="headerButtons"
                  [searchColumns]="groupColumns"></data-table>

      <data-table *ngIf="activeNavigation === 'addressbooks' && addressbookParams" (edit)="selected($event)" (remove)="deleteGroup($event)"
                  [columns]="groupColumns" [searchAll]="true" [dataProviderParams]="addressbookParams" [dataProvider]="groupService"
                  [title]="'userAdmin.' + activeNavigation | translate" [headerButtons]="headerButtons" [searchColumns]="groupColumns"
                  [newHeader]="true"></data-table>

      <data-table *ngIf="activeNavigation === 'frontend-groups' && frontGroupParams" (edit)="selected($event)"
                  (remove)="deleteGroup($event)" [title]="'userAdmin.' + activeNavigation | translate" [headerButtons]="headerButtons"
                  [columns]="groupColumns" [searchAll]="true" [dataProviderParams]="frontGroupParams" [dataProvider]="groupService"
                  [searchColumns]="groupColumns" [newHeader]="true"></data-table>

      <data-table *ngIf="activeNavigation === 'profiles' && profileParams" (edit)="selected($event)" (remove)="deleteProfile($event)"
                  [columns]="profileColumns" [searchAll]="true" [dataProviderParams]="profileParams" [dataProvider]="profileService"
                  [title]="'userAdmin.' + activeNavigation | translate" [headerButtons]="headerButtons" [searchColumns]="profileColumns"
                  [newHeader]="true" [checkBoxActions]="profileCheckboxActions"></data-table>

      <data-table *ngIf="activeNavigation === 'frontend-profiles' && frontProfileParams" (edit)="selected($event)"
                  (remove)="deleteFrontProfile($event)" [dataProvider]="frontProfileService" [searchColumns]="frontProfileColumns"
                  [columns]="frontProfileColumns" [searchAll]="true" [dataProviderParams]="frontProfileParams"
                  [title]="'userAdmin.' + activeNavigation | translate" [headerButtons]="headerButtons"
                  [newHeader]="true" [checkBoxActions]="frontProfileCheckboxActions"></data-table>
    </div>
  </div>
</page-content>
